const headers = {
  name: "Supplier",
  navigate: {
    path: [
      {
        name: "Suppliers",
        path: "/app/suppliers",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
